import { useContext, useEffect, useState } from 'react'
import { Box, Collapse, Stack, Typography } from '@mui/material'
import { noop } from 'lodash'
import { Logger, ConditionalHiddenInput, Field } from '@wolfdanepug/common-react'
import { CartContext } from '../context/cart/CartContext'
import { SegmentComponentProps } from '../types'

export default function UserInfo({ data = {}, setCanStepForward = noop }: SegmentComponentProps) {
	// Set the name state with the value from the data prop or an empty string
	const [name, setName] = useState<string>(data?.name || '')
	const [email, setEmail] = useState<string>(data?.email || '')
	// Get the cart state from the context
	const { useCartState } = useContext(CartContext)
	const cartState = useCartState()

	useEffect(() => {
		data?.name && setName(data.name)
	}, [data?.name])

	useEffect(() => {
		Logger.log('[UserInfo] name', name)
		name && setCanStepForward(name.length > 2)
	}, [name])

	const handleChange = ({ target }: any) => {
		setName(target.value)
	}

	return (
		<>
			<ConditionalHiddenInput name="coupon" value={cartState?.discountCode} />
			<ConditionalHiddenInput name="referral" value={cartState?.referral} />
			<ConditionalHiddenInput name="channel" value={cartState?.channel} />
			<Stack gap={2} justifyContent={'center'} flex={1}>
				<Box sx={styles.root}>
					<Typography variant="body1" sx={styles.text}>
						My name is
					</Typography>

					<Field
						required
						name={'name'}
						variant="standard"
						value={name}
						onChange={handleChange}
						sx={styles.field}
						color={'primary'}
					/>
				</Box>
				<Collapse in={name.length > 3}>
					<Stack
						direction={{
							xs: 'column',
							md: 'row'
						}}
						alignItems="center"
						justifyContent="center"
						gap={1}
						pr={{
							xs: 2,
							md: 0
						}}
						pl={{
							xs: 2,
							md: 0
						}}
					>
						<Typography variant="body1" sx={styles.text}>
							My email is
						</Typography>

						<Field
							required
							name={'email'}
							variant="standard"
							value={email}
							onChange={({ target }: any) => setEmail(target.value)}
							color={'primary'}
							sx={styles.email}
						/>
					</Stack>
				</Collapse>
			</Stack>
		</>
	)
}

const styles: any = {
	text: {
		whiteSpace: 'noWrap'
		// fontSize: '1.2rem'
	},
	root: {
		// flex: 1,
		display: 'flex',
		alignItems: 'center',
		maxWidth: 'sm',
		margin: '0em auto',
		flexDirection: {
			xs: 'column',
			md: 'row'
		},
		gap: 1
	},
	field: {
		field: {
			transform: 'translateY(-3px)',
			'& .MuiInput-input': {
				textAlign: 'center'
				// fontSize: '1.2rem'
			}
		}
	},
	email: {
		field: {
			transform: 'translateY(-3px)',
			width: {
				xs: '100%',
				md: '350px'
			},
			// fontSize: '1.2rem'

			'& input': {
				textAlign: 'center'
			}
		}
	}
}
